'use client';

import { useRouter } from 'next/navigation';
import { updateFeedbackStatus } from '@/lib/actions';

const statuses = [
  {
    value: 'pending',
    label: 'Pending',
    base: 'bg-amber-900/40 text-amber-300 border-amber-500/30 hover:bg-amber-900/60',
    ring: 'ring-amber-400',
  },
  {
    value: 'in_progress',
    label: 'In Progress',
    base: 'bg-blue-900/40 text-blue-300 border-blue-500/30 hover:bg-blue-900/60',
    ring: 'ring-blue-400',
  },
  {
    value: 'done',
    label: 'Done',
    base: 'bg-emerald-900/40 text-emerald-300 border-emerald-500/30 hover:bg-emerald-900/60',
    ring: 'ring-emerald-400',
  },
];

interface Props {
  feedbackId: string;
  currentStatus: string;
}

export default function FeedbackStatusControl({ feedbackId, currentStatus }: Props) {
  const router = useRouter();

  const handleStatus = async (status: string) => {
    await updateFeedbackStatus(feedbackId, status);
    router.refresh();
  };

  return (
    <div className="flex gap-2 flex-wrap">
      {statuses.map(s => (
        <button
          key={s.value}
          onClick={() => handleStatus(s.value)}
          className={`px-3 py-1.5 rounded-lg border text-xs font-mono uppercase tracking-widest transition-all ${s.base} ${
            currentStatus === s.value ? `ring-2 ring-offset-2 ring-offset-slate-950 ${s.ring}` : 'opacity-60'
          }`}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}
